import React from 'react';
import styled from '@emotion/styled';
import { useSessionStore, useAuthStore } from '../../stores/';
import { useNavigate } from 'react-router-dom';

import { green } from '@mui/material/colors';

import { Badge, Divider, Tooltip, Menu, MenuItem, IconButton as MuiIconButton } from '@mui/material';
import { spacing } from '@mui/system';
import AccountAvatar from '../common/AccountAvatar';

const IconButton = styled(MuiIconButton)(spacing);

const AvatarBadge = styled(Badge)`
  margin-right: ${(props) => props.theme.spacing(1)};
  span {
    background-color: ${() => green[400]};
    border: 2px solid ${(props) => props.theme.palette.background.paper};
    height: 12px;
    width: 12px;
    border-radius: 50%;
  }
`;

function NavbarUserDropdown() {
  // const toggleThemeDrawer = useAppShellStore.use.toggleThemeDrawer();
  const [anchorMenu, setAnchorMenu] = React.useState<any>(null);
  const email = useSessionStore.use.email();
  const signOut = useAuthStore.use.signOut();
  const navigate = useNavigate();

  const toggleMenu = (event: React.SyntheticEvent) => {
    setAnchorMenu(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorMenu(null);
  };

  const handleSignOut = async () => {
    await signOut();
    navigate('/auth/sign-in');
  };

  // Leaving this here in case we add back the theme drawer in the future
  // const openThemeDrawer = () => {
  //   closeMenu();
  //   toggleThemeDrawer(true);
  // };

  const navigateToUserProfile = () => {
    closeMenu();
    navigate('/user-profile');
  };

  const navigateToCustomerProfile = () => {
    closeMenu();
    navigate('/customer-profile');
  };

  return (
    <>
      <Tooltip title={email}>
        <IconButton aria-owns={anchorMenu ? 'menu-appbar' : undefined} aria-haspopup="true" onClick={toggleMenu} color="inherit" p={0} ml={4} mr={2}>
          <AvatarBadge
            overlap="circular"
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            variant="dot"
          >
            <AccountAvatar name={email ?? ''} />
          </AvatarBadge>
        </IconButton>
      </Tooltip>
      <Menu id="menu-appbar" anchorEl={anchorMenu} open={Boolean(anchorMenu)} onClose={closeMenu}>
        <MenuItem onClick={navigateToCustomerProfile}>Profile</MenuItem>
        <MenuItem onClick={navigateToUserProfile}>Security</MenuItem>
        <Divider />
        <MenuItem onClick={handleSignOut}>Sign out</MenuItem>
      </Menu>
    </>
  );
}

export default NavbarUserDropdown;
